export const AboutData = {
  Intro:
    "Outlast Football Academy was founded with a clear vision: to create a training ground where aspiring footballers can sharpen their skills, build character, and unlock their potential. Our academy is committed to providing high-quality football education and development for players of all ages and abilities.",
  Our_story: {
    img: "/assets/story.jpg",
    content:
      "Founded in 2022 , Outlast Football Academy has grown from a small group of passionate footballers to a leading football training facility in Perumbakkam. With the goal of providing the best training and opportunities for players",
    content_2:
      "Our academy is dedicated to offering a comprehensive training experience for players of all skill levels. From beginners taking their first steps into the game, to aspiring professionals aiming for the top, we provide expert coaching, personalized development plans, and a supportive environment where players can achieve their full potential.",
  },
  Our_philosophy:
    "we believe that football is more than just a game; it’s an opportunity to develop life skills such as teamwork, leadership, and discipline. We strive to create an environment where players can learn from their mistakes, celebrate their achievements, and grow not just as athletes but as individuals.",
  Our_values: [
    {
      id: 1,
      name: "Excellence",
      content:
        "We aim for the highest standards in all aspects of our academy.",
      img: "assets/v-icon5.jpg",
    },
    {
      id: 2,
      name: "Integirity",
      content:
        " We teach players the importance of honesty, respect, and fair play.",
      img: "assets/teach.jpg",
    },
    {
      id: 3,
      name: "Passion",
      content:
        "We foster a love for the game and a commitment to continuous improvement.",
      img: "assets/value3.jpg",
    },
    {
      id: 4,
      name: "Teamwork",
      content:
        "Success in football is built on collaboration, unity, and mutual support.",
      img: "assets/v-icon7.jpg",
    },
  ],

  Our_coach: {
    Intro:
      "Our coaches are dedicated to providing top-tier football training. They are highly qualified, with years of experience in both playing and coaching at professional levels. With UEFA coaching licenses and a passion for the game, our team is committed to helping each player reach their full potential.",
    images: [
      {
        id: "1",
        name: "Keerthi",
        img: "/assets/coach1.jpg",
        role: "COACH",
      },
      {
        id: "2",
        name: "Evan Visu",
        img: "/assets/coach2.jpg",
        role: "COACH",
      },
      {
        id: "3",
        name: "Ashwin",
        img: "/assets/coach3.jpg",
        role: "COACH",
      },
      {
        id: "4",
        name: "Kishaan",
        img: "/assets/coach4.jpg",
        role: "COACH",
      },
      {
        id: "5",
        name: "Vishwa",
        img: "/assets/coach5.jpg",
        role: "COACH",
      },
      {
        id: "6",
        name: "Vinoth",
        img: "/assets/coach6.jpg",
        role: "COACH",
      },
      {
        id: "7",
        name: "Avinash",
        img: "/assets/coach7.jpg",
        role: "COACH",
      },
      {
        id: "8",
        name: "Martin",
        img: "/assets/coach8.jpg",
        role: "COACH",
      },
         {
        id: "9",
        name: "Dhilip",
        img: "/assets/coach9.jpg",
        role: "COACH",
      }
    ],
  },
  Unique: [
    {
      id: 1,
      content:
        "We focus on the complete player, offering training in technical skills, tactical awareness, fitness, and mental resilience.",
      img: "/assets/uq1.jpg",
    },
    {
      id: 2,
      content:
        "Regular competitive matches, tournaments, and scouting opportunities give our players the chance to shine and level up.",
      img: "/assets/uq2.jpg",
    },
    {
      id: 3,
      content:
        "We use the latest techniques in fitness, agility, ball control, and tactical awareness to develop well-rounded players.",
      img: "/assets/uq3.jpg",
    },
    {
      id: 4,
      content:
        "We track each player’s progress and offer personalized feedback to help them grow faster and stronger — mentally and physically.",
      img: "/assets/uq4.jpg",
    },
    {
      id: 5,
      content:
        "We teach responsibility, teamwork, and a winner’s mindset — values that extend beyond the football field.",
      img: "/assets/uq5.jpg",
    },
    {
      id: 6,
      content:
        "Each coach at our academy combines technical excellence with heartfelt mentorship ensuring every child feels supported, valued, and inspired.",
      img: "/assets/care.jpg",
    },
  ],
  Why_Choose: [
    {
      id: 1,
      icon: "/assets/expert-coach.png",
      title: "Expert Coaching Team",
      content:
        "Our experienced and certified coaches bring top-level expertise and a passion for developing players of all ages and skill levels.",
    },
    {
      id: 2,
      icon: "/assets/focus.png",
      title: "Player-Focused Development",
      content:
        "We tailor our training programs to suit each player’s individual goals—whether it's improving skills, fitness, or tactical understanding.",
    },
    {
      id: 3,
      icon: "/assets/facilities.png",
      title: "World-Class Facilities",
      content:
        "Train like the pros with access to high-quality pitches, modern fitness equipment, and safe, clean training environments.",
    },
    {
      id: 4,
      icon: "/assets/pathway.png",
      title: "Pathway to Professional Football",
      content:
        "We offer connections with scouts and clubs programs to help talented players reach the next level.",
    },
    {
      id: 5,
      icon: "/assets/leadership.png",
      title: "Character & Leadership Training",
      content:
        "We don’t just build better players—we build better people. Discipline, teamwork, and confidence are at the core of our approach.",
    },
    {
      id: 6,
      icon: "/assets/vibe.png",
      title: "Community & Family Vibes",
      content:
        "We're more than a football academy—we’re a family. Supportive staff, passionate fans, and an environment where everyone feels welcome.",
    },
  ],
};
